export const buildNumber = '20260804.1';
export const version = 'main';
export const latestCommit = 'e851261050428cf2e12f52c35194776f8c5b840c';
